import React from 'react'

const Error = (props) => {
    if (props.message === null || props.message.length <= 0 || props.active) {
        return null
    }
    return (
        <div className="alert alert-danger text-center" role="alert">
            {props.message}
        </div>
    )
}

export default React.memo(Error)